// @file Update post heights for a specific wall and screen width

import { captureFetchException } from '@@/bits/error_tracker'
import { asciiSafeStringify } from '@@/bits/json_stringify'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { HashId } from '@@/types'
import { HTTPMethod } from '@padlet/fetch'
const API_VERSION = 1

class WishesHeightApi extends FetchableObject {
  public static get url(): string {
    return `/api/${API_VERSION}/walls/\${ wallHashid }/wishes-height`
  }

  /**
   * Store post heights for a specific wall and screen width
   */
  public static async storeWishesHeights(
    wallHashid: HashId,
    heights: Record<string, number>,
    screenWidth: number,
  ): Promise<void> {
    try {
      await fetchJson(this.buildUrl(this.url, { wallHashid }), {
        method: HTTPMethod.post,
        headers: {
          'Content-Type': 'application/json',
        },
        body: asciiSafeStringify({
          heights,
          screen_width: screenWidth,
        }),
      })
    } catch (e) {
      captureFetchException(e, {
        source: 'WishesHeightApi',
        wallHashid,
        heights,
        screenWidth,
      })
    }
  }
}

export { WishesHeightApi }
